<template>
    <StateSwitch :state="status">
        <slot
            name="default"
            :entries="entries"
        />
    </StateSwitch>
</template>

<script setup lang="ts">
import type { UpdateEntryTypeSimpleFragment } from '~/types/craft-schema';
import UpdatesQuery from '~/graphql/queries/Updates.graphql';

const props = defineProps<{
    artist?: number[];
    eventContent?: number[];
    festival?: number[];
    productionHouse?: number[];
    venue?: number[];
}>();

const { artist, eventContent, festival, productionHouse, venue } = toRefs(props);

type RelatedToCategoriesType = {
    laravelModelId: number[];
    group: 'artist' | 'eventContent' | 'festival' | 'productionHouse' | 'venue';
}

const variables = computed(() => {
    const res = {
        relatedToCategories: [] as RelatedToCategoriesType[]
    };

    if (artist.value && artist.value?.length > 0) {
        res.relatedToCategories.push({
            laravelModelId: artist.value,
            group: 'artist',
        });
    }

    if (eventContent.value && eventContent.value?.length > 0) {
        res.relatedToCategories.push({
            laravelModelId: eventContent.value,
            group: 'eventContent',
        });
    }

    if (festival.value && festival.value?.length > 0) {
        res.relatedToCategories.push({
            laravelModelId: festival.value,
            group: 'festival',
        });
    }

    if (productionHouse.value && productionHouse.value?.length > 0) {
        res.relatedToCategories.push({
            laravelModelId: productionHouse.value,
            group: 'productionHouse',
        });
    }

    if (venue.value && venue.value?.length > 0) {
        res.relatedToCategories.push({
            laravelModelId: venue.value,
            group: 'venue',
        });
    }

    return res;
});

const { data, status } = await useAsyncQuery({
    query: UpdatesQuery,
    variables
});

const entries = computed(() => {
    if (data.value?.entries) {
        return data.value.entries as UpdateEntryTypeSimpleFragment[];
    }

    return [];
});
</script>
